/* global axios */
import ApiClient from './ApiClient';

// Um File dentro de um corpo JSON serializa como `{}`: a requisição responde 200,
// a tela mostra sucesso e o arquivo nunca subiu. Detectar aqui evita que qualquer
// chamador caia nisso — inclusive um futuro que não conheça a regra.
const hasFile = payload =>
  payload instanceof FormData ||
  (payload &&
    typeof payload === 'object' &&
    Object.values(payload).some(
      value => typeof File !== 'undefined' && value instanceof File
    ));

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  // CRIAÇÃO É SEMPRE JSON. A conversão de objeto para multipart é lossy: `null`
  // some, booleano e número viram string, objeto aninhado vira "[object Object]"
  // e array vazio desaparece — e array vazio é como se revogam todas as
  // permissões de um robô. O avatar sobe numa segunda requisição, pelo `update`,
  // com o id que a criação devolve. Duas requisições, cada uma no formato que
  // lhe cabe, em vez de uma que perde tipo.
  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    if (data instanceof FormData || hasFile(data)) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.patch(`${this.url}/${id}`, data);
  }

  deleteAgentBotAvatar(botId) {
    return axios.delete(`${this.url}/${botId}/avatar`);
  }

  resetAccessToken(botId) {
    return axios.post(`${this.url}/${botId}/reset_access_token`);
  }

  resetSecret(botId) {
    return axios.post(`${this.url}/${botId}/reset_secret`);
  }
}

export default new AgentBotsAPI();
